export const breakpoints = {
  sm: '36em',
  md: '48em',
  lg: '62em',
  xl: '75em',
};
